export const translations = {
  communitySupport: {
    'fr': 'Support Communauté',
    'de': 'Community Support',
    'tr': 'topluluk desteği',
    'it': 'Supporto dalla Community',
    'es': 'Preguntas Frecuentes',
    'sv': 'Support från Community'
  },
  seeAll: {
    'fr': 'Voir tout',
    'de': 'Alles anzeigen',
    'tr': 'hepsini gör',
    'it': 'Vedi tutto',
    'es': 'Ver todo',
    'sv': 'Se allt'
  },
  viewAll: {
    'fr': 'Voir tout',
    'de': 'Alle ansehen',
    'tr': 'Hepsini gör',
    'it': 'Mostra tutto',
    'es': 'Ver todo',
    'sv': 'Visa alla'
  },
  communitySupportLabel: {
    'fr': 'Bénéficiez d`une assistance 24h/24 et 7j/7 de vos pairs et experts',
    'de': '24/7-Support von Ihren Kollegen und Experten',
    'tr': 'Meslektaşlarınızdan ve uzmanlarınızdan 7/24 destek alın',
    'it': 'Ottieni supporto 24/7 da colleghi ed esperti',
    'es': 'Obtén asistencia de tus colegas y los expertos las 24 horas del día, los 7 días de la semana',
    'sv': 'Få support från dina kollegor och experter dygnet runt'
  },
};
